/**
 * When true, merchants can enable visit rewards, create visit-type rewards, and configure
 * punch-card-style Apple Wallet strip images (visit-based strip path today; spend/package punch tracks evolve separately).
 * Defaults off until product is ready.
 *
 * CRA: set REACT_APP_VISIT_AND_PUNCH_CARD_REWARDS_ENABLED=true in .env for local testing.
 */
export const VISIT_AND_PUNCH_CARD_REWARDS_UI_ENABLED =
    process.env.REACT_APP_VISIT_AND_PUNCH_CARD_REWARDS_ENABLED === 'true';

/**
 * When true, merchants can create birthday-type rewards from the Rewards page. Defaults off until
 * Rewards Settings exposes a working birthday toggle (DB may still have birthday_enabled for legacy rows).
 *
 * CRA: set REACT_APP_BIRTHDAY_REWARDS_ENABLED=true in .env for local testing.
 */
export const BIRTHDAY_REWARDS_UI_ENABLED =
    process.env.REACT_APP_BIRTHDAY_REWARDS_ENABLED === 'true';
